<template>
  <div class="asc-centered-text--container">
    <span class="asc-centered-text--title">{{ value }}</span>
  </div>
</template>

<script>
export default {
  name: 'AscCenteredText',

  props: {
    value: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss">
.asc-centered-text--container {
  background-color: $primary-white;
  width: 100%;
  height: 80px;

  & .asc-centered-text--title {
    display: block;
    position: relative;
    top: 40%;
    text-align: center;
  }
}
</style>
